import {UIGameCardContainerView} from '../ui_game_card/UIGameCardContainerView'
import {UIGameManager} from '../UIGameManager'
import {PIXI} from '@colonist/pixi'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {CardEnum} from '@colonist/game-states'

export class UIGamePopupSelectCardContainerView extends SectionView {
    private readonly uiGameManager: UIGameManager

    cardsToSelectFrom: UIGameCardContainerView
    cardsSelected: UIGameCardContainerView

    constructor(uiGameManager: UIGameManager, x: number, y: number, w: number, h: number, clickedTopResource: (cardEnum: CardEnum) => void, clickedBottomResource: (cardEnum: CardEnum) => void, activeCards: CardEnum[], container: PIXI.Container, disabledCards: CardEnum[] | undefined) {
        super(x, y, w, h, container)
        this.uiGameManager = uiGameManager

        const topCardH = h * 0.45
        const selectedCardH = h * 0.55

        this.cardsToSelectFrom = new UIGameCardContainerView(this.uiGameManager, 0, 0, w, topCardH, this)
        this.cardsToSelectFrom.setCardClickAction(clickedTopResource)
        const animate = false
        this.cardsToSelectFrom.addMultipleCards(activeCards, animate)
        if(disabledCards != undefined) this.cardsToSelectFrom.disableCards(disabledCards)
        this.cardsToSelectFrom.cardInventory.hideCardBadges()

        const disableBg = true
        const cardContainerY = this.cardsToSelectFrom.y + this.cardsToSelectFrom.height
        this.cardsSelected = new UIGameCardContainerView(this.uiGameManager, 0, cardContainerY, w, selectedCardH, this, disableBg)
        this.cardsSelected.setCardClickAction((cardEnum: CardEnum) => {
            this.cardsSelected.removeCard(cardEnum)
            clickedBottomResource(cardEnum)
        })
    }
}
